import { Loader, Title } from "@mantine/core";
import * as Sentry from "@sentry/browser";
import HubspotForm from "react-hubspot-form";
import urls from "../../urls";
import { SiteName } from "../../utils/enums";
import { AnchorLink } from "../AnchorLink/AnchorLink";

declare const SITE_NAME: SiteName;

function Support() {
  const phone = (
    <PhoneLink phoneNumber="+4969588098859">069 5880988 59</PhoneLink>
  );
  let content: React.ReactNode = null;
  let email: React.ReactNode;

  switch (SITE_NAME) {
    case SiteName.Optinode:
    case SiteName.Wavelr:
    case SiteName.Alva:
      email = <EmailLink emailAddress="support@node.energy" />;
      content = (
        <>
          <div>
            <Title order={2}>Schnelle Hilfe</Title>
            <p style={{ marginBottom: "20px" }}>
              Die Antworten auf die häufigsten Fragen finden Sie in unserer{" "}
              <AnchorLink href={urls.optiSupport()}>opti.node-Hilfe</AnchorLink>
              .
            </p>
          </div>
          <div style={{ marginBottom: "20px" }}>
            <Title order={2}>Kontakt-Formular</Title>
            <p>
              Sie haben in der opti.node-Hilfe keine Antwort auf Ihre Frage
              bekommen? Dann können Sie uns über dieses Kontakt-Formular direkt
              erreichen. Wir helfen Ihnen gerne weiter:
            </p>
            <HubspotForm
              formId="be23f3ff-ad6d-45dd-a8f9-fc383a3a618b"
              loading={
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Loader />
                </div>
              }
              portalId="25500712"
            />
          </div>
          <Title order={2}>Weitere Kontaktmöglichkeiten</Title>
          <p>
            Alternativ können Sie uns auch telefonisch oder per Mail erreichen:
          </p>
          <p>
            Telefon: {phone}
            <br />
            E-Mail: {email}
          </p>
        </>
      );
      break;
    case SiteName.Smarendo:
      email = <EmailLink emailAddress="smarendo@node.energy" />;
      content = (
        <>
          <span>
            Bei Fragen zur Nutzung von SMARENDO (Software-Support) wenden Sie
            sich bitte an:
          </span>
          <br />
          <br />
          <p>
            Telefon: {phone}
            <br />
            E-Mail: {email}
          </p>
        </>
      );
      break;
    default:
      Sentry.captureMessage(
        `Unsupported SITE_NAME ${SITE_NAME} used on Support page! This needs to be implemented to show the right message and contact details.`
      );
      break;
  }

  return <div className="Support">{content}</div>;
}

function EmailLink({ emailAddress }: { emailAddress: string }) {
  return (
    <AnchorLink href={`mailto:${emailAddress}`} target="_self">
      {emailAddress}
    </AnchorLink>
  );
}

function PhoneLink({
  phoneNumber,
  children
}: {
  phoneNumber: string;
  children: React.ReactNode;
}) {
  return (
    <AnchorLink href={`tel:${phoneNumber}`} target="_self">
      {children}
    </AnchorLink>
  );
}

export { Support };
